<template>
	<div class="ws-tutorial-tooltip" ref="tooltip" :data-step="tutorial.currentStep" 
		:data-tooltip="tooltip" v-click-outside="warnDisabled" :class="{ shake: disabled }">
		<img :src="tutorial.steps[tutorial.currentStep].img" alt="Generate Link" />
		<div class="content-wrapper">
			<span class="heading">{{ tutorial.steps[tutorial.currentStep].heading }}</span>
			<p class="desc">{{ tutorial.steps[tutorial.currentStep].text }}</p>
			<div class="nav">
				<span id="back" :class="(tutorial.currentStep === 0) ? 'disabled' : ''" @click.stop="previousStep">Back</span>
				<div id="tutorial-steps">
					<span v-for="(item, index) in tutorial.steps" 
					class="tutorial-step" :data-index="index" :data-step="item.id"
					:class="(index === tutorial.currentStep) ? 'active' : ''"
					@click.stop="goToStep(index)"></span>
				</div>
				<span id="next" :class="((tutorial.currentStep + 1) === tutorial.steps.length) ? 'disabled' : ''" @click.stop="nextStep">Next</span>
			</div>
			<span id="done" v-if="(tutorial.currentStep + 1) === tutorial.steps.length" @click.stop="closeTutorial('done')">Done!</span>
		</div>
		<div class="ws-tooltip-close close-button" @click.stop="closeTutorial('paused')"></div>
	</div>
</template>

<script>

export default {
	name: "TutorialTooltip",
	props: ['location', 'tooltip'],
	data() {
		return {
			defaultWidth: 450,
			disabled: false
		}
	},
	methods: {
		closeTutorial(ev) {
			this.$store.commit('tutorials/hideTutorial', this.location);

			if (this.sidebarShown) this.toggleSidebar();
			if (ev) {
				let ttlCookie = { status: ev };
				if (ev === 'paused') ttlCookie.step = this.tutorial.currentStep;
				this.$cookies.set('ws_tutorial', ttlCookie);
			}
		},
		nextStep() {
			this.$store.commit('tutorials/nextStep', this.location);
			this.stepChangeEvents();
		},
		previousStep() {
			this.$store.commit('tutorials/previousStep', this.location);
			this.stepChangeEvents();
		},
		goToStep(step) {
			this.$store.commit('tutorials/setStep', { tutorial: this.location, step: step });
			this.stepChangeEvents();
		},
		warnDisabled() {
			this.disabled = true;
			setTimeout(() => {
				this.disabled = false
			}, 1500);
		},
		stepChangeEvents() {
			if (window.innerWidth <= this.$store.state.sidebarBP) {
				if (this.isStepInMenu) {
					if (!this.sidebarShown) this.toggleSidebar();
				} else {
					if (this.sidebarShown) this.toggleSidebar();
				}
			}
		},
		maybeScrollIntoView() {
			/*const sidebarMenu = document.querySelector('#worksends-left-sidebar-content');
			const tooltip = this.$refs.tooltip;

			if (this.isStepInMenu) {
				sidebarMenu.scrollTo(0,0);
				if (!this.isInViewport(tooltip)) {
					let mTop = 50;
					while (!this.isInViewport(tooltip) && mTop < 500) {
						document.querySelector('#worksends-left-sidebar-content').style.marginTop = `-${mTop}px`;
						mTop += 50;
					}
					if (!this.isInViewport(tooltip)) document.querySelector('.ws-tutorial-tooltip img').style.display = 'none';
				}
			} else {
				document.querySelector('.site-main').scrollTo(0,0);
				if (!this.isInViewport(tooltip)) {
					if (this.tutorial.currentStep === 0) {
						tooltip.scrollIntoView({ block: 'nearest' });
					} else tooltip.scrollIntoView();
				}
			}*/
		},
		toggleSidebar() {
			this.$root.$emit('bv::toggle::collapse', 'worksends-left-sidebar-toggle');
		}
	},
	directives: {
		'click-outside': {
			bind: function (el, binding, vnode) {
				el.clickOutsideEvent = function (event) {
					if (!(el == event.target || el.contains(event.target))) {
						vnode.context[binding.expression](event);
					}
				};
				document.body.addEventListener('click', el.clickOutsideEvent)
			},
			unbind: function (el) {
				document.body.removeEventListener('click', el.clickOutsideEvent)
			},
		}
	},
	mounted() {
		document.querySelector('#worksends-left-sidebar-content').style.marginTop = '0px';
		document.body.classList.add('ws-modal', 'ws-tutorial');
		document.documentElement.classList.add('no-scroll-modal');
		if (this.isStepInMenu) {
			setTimeout(this.maybeScrollIntoView, 300);
		} else this.maybeScrollIntoView();
	},
	destroyed() {
		document.querySelector('#worksends-left-sidebar-content').style.marginTop = '0px';
	},
	computed: {
		modals() {
			return this.$store.state.modals;
		},
		tutorial() {
			return this.$store.state.tutorials[this.location];
		},
		activeTutorial() {
			return this.$store.getters['tutorials/getActiveTutorial'];
		},
		sidebarShown() {
			return this.$store.state.sidebarShown;
		},
		isStepInMenu() {
			return this.tutorial.steps[this.tutorial.currentStep].inMenu;
		}
	},
}
</script>

<style scoped>
.shake {
	animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
	transform: translate3d(0, 0, 0);
}

@keyframes shake {
	10%,
	90% {
		transform: translate3d(-1px, 0, 0);
	}

	20%,
	80% {
		transform: translate3d(2px, 0, 0);
	}

	30%,
	50%,
	70% {
		transform: translate3d(-4px, 0, 0);
	}

	40%,
	60% {
		transform: translate3d(4px, 0, 0);
	}
}
</style>